import { useLocalizationContext } from './useLocalizationContext';

export const useTranslation = () => {
    const { localizationService } = useLocalizationContext();
    const translationFunction = localizationService.get;
    return translationFunction;
};
